import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const DEFAULT_STYLES: StyleObj = {
  message: {
    backgroundColor: 'neutral.50',
    borderBottom: (theme) => `1px solid ${theme.palette.neutral[100]}`,
    py: 0.5,
    fontSize: 11,
    color: 'neutral.600',
  },
};

const NEOBET_STYLES: StyleObj = {
  ...DEFAULT_STYLES,
  message: {
    ...DEFAULT_STYLES.message,
    backgroundColor: 'neutral.600',
    color: 'primary.main',
    border: '1px solid',
    borderColor: 'primary.main',
  },
};

export const BETSLIP_INFO_MESSAGE_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: DEFAULT_STYLES,
  [SKIN.GOLA]: DEFAULT_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};
